import { ReactNode, useState } from "react";
import { FaArrowCircleUp } from "react-icons/fa";
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "@jammable/ui-components/Dialog";
import { cn, primaryButtonStyles, toast } from "@jammable/ui-core";
import { Upgrade } from "./Upgrade";
import { Subscribe } from "./Subscribe";

export function NoCredits({
  freeLimit = false,
  needCreator = false,
  noCredits = true,
  fallback,
  callback,
  renderCheckout,
  className,
  message,
  quota,
}: {
  freeLimit?: boolean;
  needCreator?: boolean;
  noCredits?: boolean;
  className?: string;
  message?: any;
  fallback?: () => void;
  callback?: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- temporary whilst we use the old checkout
  renderCheckout?: (props: any) => ReactNode;
  quota?: any;
}) {
  // beacuase we auto open it, we need to force close it when the user clicks the cross
  const [forceCloseSubModal, setForceCloseSubModal] = useState(false);

  const handleCheckoutTrigger = () => {
    // temporary whilst the checkout is not availale in new code, go to pricing page
    if (!renderCheckout) {
      // @ts-expect-error allow window location
      window.location = "/pricing";
    }
  };

  return (
    <div
      className={cn(
        "tw-flex tw-h-full tw-flex-col tw-items-center tw-justify-center tw-gap-6 tw-rounded-3xl tw-border tw-bg-white tw-px-10 tw-py-4 tw-text-center tw-shadow tw-backdrop-blur-md",
        className,
      )}
    >
      <Dialog
        open={!forceCloseSubModal && (freeLimit || noCredits || needCreator)}
        onOpenChange={(open) => setForceCloseSubModal(!open)}
      >
        <DialogTrigger
          className="tw-border-0 tw-bg-transparent"
          onClick={handleCheckoutTrigger}
        >
          <div className="tw-mx-auto tw-my-10 tw-flex tw-max-w-lg tw-flex-col tw-gap-6 tw-tracking-tight">
            <div className="tw-mx-auto tw-inline-flex tw-h-12 tw-w-20 tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-rounded-4xl tw-bg-purple-700/10 tw-px-3">
              <FaArrowCircleUp size={32} className="tw-text-purple-700" />
            </div>
            <div className="tw-text-center tw-text-xl tw-font-bold tw-leading-normal tw-text-black">
              {message?.message}
              <p className="tw-tracking-tight tw-opacity-80">
                Upgrade to unlock all voices.
              </p>
            </div>
            <div
              className={`tw-rounded-full ${primaryButtonStyles} tw-rounded-full md:tw-rounded-full`}
            >
              {freeLimit
                ? "Upgrade Plan"
                : needCreator
                  ? "Upgrade Plan"
                  : "Get More Credits"}
            </div>
          </div>
        </DialogTrigger>
        <DialogContent className="tw-p-0" drawerMode>
          {needCreator ? (
            <Upgrade
              type="Jammable Creator"
              fallback={() => fallback?.()}
              callback={() => {
                toast.success("Your subscription has been updated!");
                callback?.();
              }}
            />
          ) : (
            <>
              {renderCheckout && (
                <Subscribe
                  quota={quota}
                  renderCheckout={renderCheckout}
                  message={message}
                  fallback={() => fallback?.()}
                  callback={() => {
                    toast.success("You have subscribed!");
                    callback?.();
                  }}
                  hasSidebar={true}
                />
              )}
            </>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
